import { trackEvent } from '@/lib/analytics'

const socialLinks = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/spoke.movie/',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61577517413587',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
  {
    label: 'Substack',
    href: 'https://filmabeestudios.substack.com/',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"/>
      </svg>
    ),
  },
]

const Footer = () => {
  return (
    <footer className="relative w-full bg-black border-t border-white/10">
      <div className="text-center pt-8">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-white/20 hover:border-yellow-400/50 text-gray-400 hover:text-yellow-400 transition-colors duration-300"
          aria-label="Back to top"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 15l-6-6-6 6" />
          </svg>
        </button>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-4 pb-2 text-center">
        <a
          href="https://filmabee-studios.kit.com/spoke"
          onClick={() => trackEvent('newsletter_click', { site: 'spoke', film: 'spoke', placement: 'footer', provider: 'kit' })}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block text-yellow-400 hover:text-yellow-300 font-poppins font-semibold text-sm tracking-widest uppercase transition-colors duration-300"
        >
          Let us know where you are. Sign up.
        </a>
      </div>

      {/* Social icons */}
      <div className="flex items-center justify-center gap-6 py-4">
        {socialLinks.map((s) => (
          <a
            key={s.label}
            href={s.href}
            onClick={() => trackEvent('social_click', { site: 'spoke', film: 'spoke', platform: s.label.toLowerCase(), placement: 'footer' })}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            className="text-gray-400 hover:text-yellow-400 transition-colors duration-300"
          >
            {s.icon}
          </a>
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-center md:text-left">
        <div className="md:flex md:items-center md:justify-between md:gap-6">
          <p className="text-white font-montserrat font-bold text-lg tracking-wide mb-2 md:mb-0">
            Filmabee Studios
          </p>
          <div className="text-gray-400 text-sm font-poppins font-light mb-2 md:mb-0 text-center">
            <p>Firefighter portraits by the amazing Alley Rutzel.</p>
            <p>Additional photography by Tzvetan Tzenov.</p>
          </div>
          <p className="text-gray-500 text-xs font-poppins">
            &copy; 2026 Filmabee Studios. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
